import { create } from "zustand";

export const useNoticeStore = create<{
  hasShowNotice: boolean;
  setHasShowNotice: (hasShowNotice: boolean) => void;
}>((set) => ({
  hasShowNotice: false,
  setHasShowNotice: (hasShowNotice) => set({ hasShowNotice }),
}));
